import * as React from 'react';
import SearchCondition from "./components/SearchCondition";
import {useEffect, useState} from "react";
import {UserSearchCondition} from "../../../../modules/account/dto/UserSearchCondition";
import {UserDto} from "../../../../modules/account/dto/UserDto";
import {PaginationDto} from "../../../../modules/common/dto/PaginationDto";
import {UserApi} from "../../../../modules/account/api/UserApi";
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../../utils/MessageUtils";
import {useIntl} from "react-intl";
import SearchResult from "./components/SearchResult";
import UserDetailDialog from "./components/UserDetailDialog";
import PaginationBar from "../../../../components/PaginationBar";
import {Paper} from "@mui/material";
import RoleDialog from "./components/RoleDialog";
import {DepartmentDto} from "../../../../modules/account/dto/DepartmentDto";
import {DepartmentApi} from "../../../../modules/account/api/DepartmentApi";

export default function Index() {
    const intl = useIntl();

    useEffect(() => {
        _handleSearch(searchCondition);
    }, []);

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new UserSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<UserDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());

    const [openDetailDialog, setOpenDetailDialog] = useState(false);

    const [openRoleDialog, setOpenRoleDialog] = useState(false);

    const [currentRow, setCurrentRow] = useState<UserDto>(new UserDto());

    // 部门的树结构列表
    const [departments, setDepartments] = useState<Array<DepartmentDto>>([]);
    // key: id, value: DepartmentDto
    const [departmentMap, setDepartmentMap] = useState(new Map<string, DepartmentDto>());

    useEffect(() => {
        _fetchDepartments();
    }, []);

    const _fetchDepartments = async () => {
        const responseResult = await DepartmentApi.getDepartmentList();
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            // 构建部门的Map
            const departmentMap = new Map<string, DepartmentDto>();
            for (let item of responseResult.data) {
                departmentMap.set(item.id, item);
            }
            setDepartmentMap(departmentMap);

            setDepartments(DepartmentApi.constructDepartmentTree(responseResult.data));
        }
    };

    const _handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const _handleSearch = async (searchCondition: UserSearchCondition) => {
        const responseResult = await UserApi.queryUsers(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const _handleClickModify = async (record: UserDto) => {
        const responseResult = await UserApi.getUserDetail(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setCurrentRow(responseResult.data);
            setOpenDetailDialog(true);
        }
    };

    const _handleClickDelete = async (record: UserDto) => {
        const responseResult = await UserApi.deleteUser(record.id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: 'COMMON_DELETE_SUCCESS'}));
            _handleSearch(searchCondition);
        }
    };

    const _handleClickAdd = () => {
        setCurrentRow(new UserDto());
        setOpenDetailDialog(true);
    };

    const _handleClickRole = (record: UserDto) => {
        setCurrentRow(record);
        setOpenRoleDialog(true);
    }

    const _handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        setSearchCondition(newSearchCondition);
        _handleSearch(newSearchCondition);
    };

    return (
        <div>
            <UserDetailDialog open={openDetailDialog} user={currentRow}
                              departments={departments}
                              departmentMap={departmentMap}
                              onClose={() => setOpenDetailDialog(false)} onOk={() => _handleSearch(searchCondition)}/>
            <RoleDialog open={openRoleDialog} userId={currentRow.id}
                        onClose={() => setOpenRoleDialog(false)} onOk={() => _handleSearch(searchCondition)}/>
            <Paper sx={{p: 1}}>
                <SearchCondition searchCondition={searchCondition}
                                 onChange={_handleChangeCondition}
                                 onClickSearch={() => _handleSearch(searchCondition)}
                                 onClickAdd={_handleClickAdd}/>
            </Paper>
            <br/>

            <Paper sx={{p: 1}}>
                <PaginationBar pagination={pagination} onChange={_handlePagination}/>
                <br/>
                <SearchResult searchResult={searchResult}
                              onClickDelete={(record) => _handleClickDelete(record)}
                              onClickModify={(record) => _handleClickModify(record)}
                              onClickRole={(record) => _handleClickRole(record)}
                              departmentMap={departmentMap}/>
            </Paper>
        </div>
    );
}